import React from "react"
import { DownloadOutlined } from "@ant-design/icons"
import { Button, notification, Table as AntTable, Typography } from "antd"
import api from "src/api"
import styled from "styled-components"

import { Header } from "../components/layout/header"
import { useUpdateHeaderTitle } from "../hooks"
import { useGetData } from "../pages-lib/abandoned-carts/model"
import { getColumns } from "../pages-lib/abandoned-carts/table-columns"

export default function AbandonedCarts() {
  const { dataItems, pagination, isLoading, handleTableChange } = useGetData()
  const [isExporting, setIsExporting] = React.useState(false)

  const headerTitle = useUpdateHeaderTitle({
    items: dataItems,
    defaultTitle: "0 корзин",
    arrType: ["корзина", "корзины", "корзин"],
  })

  const columns = getColumns()

  async function onExport() {
    setIsExporting(true)
    try {
      const file = await api.get("abandoned-carts/export", {
        responseType: "blob",
      })

      const blob = new Blob([file], { type: "text/csv;charset=utf-8" })
      const url = window.URL.createObjectURL(blob)

      const link = document.createElement("a")
      link.href = url
      link.download = `abandoned-carts-${new Date()
        .toISOString()
        .slice(0, 10)}.csv`
      document.body.appendChild(link)
      link.click()
      link.remove()

      window.URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Ошибка выгрузки CSV", error)
      notification.error({ message: "Ошибка выгрузки CSV" })
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraRow>
            <Hint type="secondary">
              Сегодняшние корзины, в которые больше часа не добавляли товар
            </Hint>
            <Button
              icon={<DownloadOutlined />}
              onClick={onExport}
              loading={isExporting}
              disabled={!dataItems.length}
            >
              Выгрузить CSV
            </Button>
          </ExtraRow>
        }
      />

      <StyledTable
        dataSource={dataItems}
        columns={columns}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={pagination}
      />
    </>
  )
}

const ExtraRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

const Hint = styled(Typography.Text)`
  font-size: 13px;
`

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
